import { useState, useEffect } from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import {
    Box, Typography, Grid, Button, TextField, InputAdornment, 
  } from "@mui/material";
import { AccountCircle } from "@mui/icons-material";

export default function UpdateBudgetDialog({ lowestTasks = [], open, setOpen, onUpdate }) {
    const [data, setData] = useState({});
    const onDataChange = (e, id) => {
      setData((prev) => ({ ...prev, [id]: e.target.value }));
      // setData((prev) => ({ ...prev, [id]: { ...prev[id], [e.target.name]: e.target.value } }));
    };
  
    useEffect(() => {
      if (!open) return;
      let temp = {};
      lowestTasks.forEach((t) => {
        temp[t.id] = t.budget;
        // temp[t.id] = { budget: t.budget, complete: t['% complete'] }
      });
      setData(temp);
    }, [open]);
  
    const onUpdateClick = () => {
      let updateData = [];
      Object.keys(data).forEach((k, i) => {
        updateData.push({ task_id: k, budget: data[k] });
        // updateData.push({ task_id: k, budget: data[k].budget, complete: data[k].complete });
      });
      if (updateData.length) onUpdate(updateData);
      else setOpen("UPDATE_BUDGET");
    };
  
    return (
      <Dialog
        open={open}
        onClose={() => {
         // setOpen("UPDATE_BUDGET");
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Update Budget</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <Box sx={{ display: "flex", alignItems: "center", p: 1 }}>
                <Box width="50%">
                  <Typography>Task Code</Typography>
                </Box>
                <Box width="50%">
                  <Typography>Budget</Typography>
                </Box>
              </Box>
            </Grid>
            {lowestTasks.map((t, i) => (
              <Grid key={i} item xs={12}>
                <Box sx={{ display: "flex", alignItems: "center", p: 1 }}>
                  <Box width="50%">
                    <Typography>{t.task_code} - {t.task_name}</Typography>
                  </Box>
                  <Box width="50%">
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      value={data[t.id] || ""}
                      // value={data[t.id]?.budget || ""}
                      name="budget"
                      label="Budget ($)"
                      onChange={(e) => {
                        onDataChange(e, t.id);
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined"
            onClick={() => {
              setOpen("UPDATE_BUDGET");
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button variant="outlined" onClick={onUpdateClick} className="blue-button" autoFocus>
            Update
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  